// src/components/RectangleLinkButton.jsx
import React from "react";
import { Button } from "@mui/material";

export default function RectangleLinkButton({
  title,
  url,
  buttonColour,
  openInNewTab = false,
}) {
  return (
    <Button
      fullWidth
      variant="contained"
      component="a"
      href={url}
      target={openInNewTab ? "_blank" : "_self"}
      rel={openInNewTab ? "noopener noreferrer" : undefined}
      sx={{
        backgroundColor: buttonColour,
        color: (theme) =>
          theme.palette.getContrastText(
            buttonColour || theme.palette.primary.main,
          ),
        textTransform: "none",
        borderRadius: 1,
        height: 48,
        "&:hover": {
          backgroundColor: buttonColour,
        },
      }}
    >
      {title}
    </Button>
  );
}
